import axios from 'axios'
import { showSnackbar, snackbarTypes } from 'src/redux/snackbar'
import { loginSuccess } from 'src/redux/identity'
import { fetchGetEmployerUser } from 'src/redux/employerUser'
import { fetchTrackEvent, ProductAnalyticsEventTypes } from 'src/redux/productAnalytics'

export const VALIDATE_EMPLOYER_USER_EMAIL_LOADING = 'employerUserSignup/VALIDATE_EMPLOYER_USER_EMAIL_LOADING'
export const VALIDATE_EMPLOYER_USER_EMAIL_SUCCESS = 'employerUserSignup/VALIDATE_EMPLOYER_USER_EMAIL_SUCCESS'
export const VALIDATE_EMPLOYER_USER_EMAIL_FAILURE = 'employerUserSignup/VALIDATE_EMPLOYER_USER_EMAIL_FAILURE'
export const EMPLOYER_USER_SIGNUP_REGISTER_LOADING = 'employerUserSignup/EMPLOYER_USER_SIGNUP_REGISTER_LOADING'
export const EMPLOYER_USER_SIGNUP_REGISTER_SUCCESS = 'employerUserSignup/EMPLOYER_USER_SIGNUP_REGISTER_SUCCESS'
export const EMPLOYER_USER_SIGNUP_REGISTER_FAILURE = 'employerUserSignup/EMPLOYER_USER_SIGNUP_REGISTER_FAILURE'
export const EMPLOYER_USER_SIGNUP_CHECK_CONFIRMATION_LOADING = 'employerUserSignup/EMPLOYER_USER_SIGNUP_CHECK_CONFIRMATION_LOADING'
export const EMPLOYER_USER_SIGNUP_CHECK_CONFIRMATION_SUCCESS = 'employerUserSignup/EMPLOYER_USER_SIGNUP_CHECK_CONFIRMATION_SUCCESS'
export const EMPLOYER_USER_SIGNUP_CHECK_CONFIRMATION_FAILURE = 'employerUserSignup/EMPLOYER_USER_SIGNUP_CHECK_CONFIRMATION_FAILURE'
export const SEARCH_EMPLOYERS_LOADING = 'employerUserSignup/SEARCH_EMPLOYERS_LOADING'
export const SEARCH_EMPLOYERS_SUCCESS = 'employerUserSignup/SEARCH_EMPLOYERS_SUCCESS'
export const SEARCH_EMPLOYERS_FAILURE = 'employerUserSignup/SEARCH_EMPLOYERS_FAILURE'
export const EMPLOYER_USER_SIGNUP_POST_JOB_LOADING = 'employerUserSignup/EMPLOYER_USER_SIGNUP_POST_JOB_LOADING'
export const EMPLOYER_USER_SIGNUP_POST_JOB_SUCCESS = 'employerUserSignup/EMPLOYER_USER_SIGNUP_POST_JOB_SUCCESS'
export const EMPLOYER_USER_SIGNUP_POST_JOB_FAILURE = 'employerUserSignup/EMPLOYER_USER_SIGNUP_POST_JOB_FAILURE'

export const validateEmployerUserEmailLoading = () => ({ type: VALIDATE_EMPLOYER_USER_EMAIL_LOADING })
export const validateEmployerUserEmailSuccess = payload => ({ type: VALIDATE_EMPLOYER_USER_EMAIL_SUCCESS, payload })
export const validateEmployerUserEmailFailure = payload => ({ type: VALIDATE_EMPLOYER_USER_EMAIL_FAILURE, payload })
export const employerUserSignupRegisterLoading = () => ({ type: EMPLOYER_USER_SIGNUP_REGISTER_LOADING })
export const employerUserSignupRegisterSuccess = payload => ({ type: EMPLOYER_USER_SIGNUP_REGISTER_SUCCESS, payload })
export const employerUserSignupRegisterFailure = payload => ({ type: EMPLOYER_USER_SIGNUP_REGISTER_FAILURE, payload })
export const employerUserSignupCheckConfirmationLoading = () => ({ type: EMPLOYER_USER_SIGNUP_CHECK_CONFIRMATION_LOADING })
export const employerUserSignupCheckConfirmationSuccess = payload => ({ type: EMPLOYER_USER_SIGNUP_CHECK_CONFIRMATION_SUCCESS, payload })
export const employerUserSignupCheckConfirmationFailure = payload => ({ type: EMPLOYER_USER_SIGNUP_CHECK_CONFIRMATION_FAILURE, payload })
export const searchEmployersLoading = () => ({ type: SEARCH_EMPLOYERS_LOADING })
export const searchEmployersSuccess = payload => ({ type: SEARCH_EMPLOYERS_SUCCESS, payload })
export const searchEmployersFailure = payload => ({ type: SEARCH_EMPLOYERS_FAILURE, payload })
export const employerUserSignupPostJobLoading = () => ({ type: EMPLOYER_USER_SIGNUP_POST_JOB_LOADING })
export const employerUserSignupPostJobSuccess = payload => ({ type: EMPLOYER_USER_SIGNUP_POST_JOB_SUCCESS, payload })
export const employerUserSignupPostJobFailure = payload => ({ type: EMPLOYER_USER_SIGNUP_POST_JOB_FAILURE, payload })

export const fetchValidateEmployerUserEmail = email => {
  return async dispatch => {
    dispatch(validateEmployerUserEmailLoading())
    try {
      const response = await axios({
        url: '/api/employer_user_signup/validate_email',
        method: 'POST',
        data: { email },
      })
      dispatch(validateEmployerUserEmailSuccess(response.data))
    } catch (error) {
      dispatch(validateEmployerUserEmailFailure(error.response))
    }
  }
}

export const fetchEmployerUserSignupRegister = data => {
  return async dispatch => {
    dispatch(employerUserSignupRegisterLoading())
    try {
      const response = await axios({
        url: '/api/employer_users/self_register',
        method: 'POST',
        data,
      })
      dispatch(employerUserSignupRegisterSuccess(response.data))
    } catch (error) {
      dispatch(showSnackbar('Failed to create your account. Please try again.', snackbarTypes.ERROR))
      dispatch(employerUserSignupRegisterFailure(error.response))
    }
  }
}

export const fetchEmployerUserSignupCheckConfirmation = ({ email, pollingToken }) => {
  return async dispatch => {
    dispatch(employerUserSignupCheckConfirmationLoading())
    try {
      const response = await axios({
        url: '/api/employer_user_signup/check_confirmation',
        method: 'POST',
        data: { email, pollingToken },
      })
      if (response.data.isConfirmed && response.data.identity) {
        dispatch(loginSuccess(response.data))
        dispatch(fetchGetEmployerUser(response.data.identity.employerUserId))
      }
      dispatch(employerUserSignupCheckConfirmationSuccess(response.data))
    } catch (error) {
      dispatch(employerUserSignupCheckConfirmationFailure(error.response))
    }
  }
}

export const fetchSearchEmployers = query => {
  return async dispatch => {
    dispatch(searchEmployersLoading())
    try {
      const response = await axios({
        url: '/api/employers/search',
        method: 'GET',
        params: { query },
      })
      dispatch(searchEmployersSuccess(response.data))
    } catch (error) {
      dispatch(searchEmployersFailure(error.response))
    }
  }
}

export const fetchEmployerUserSignupPostJob = data => {
  return async dispatch => {
    dispatch(employerUserSignupPostJobLoading())
    try {
      const response = await axios({
        url: '/api/employer_user_signup/post_job',
        method: 'POST',
        data,
      })
      dispatch(employerUserSignupPostJobSuccess(response.data))
    } catch (error) {
      dispatch(showSnackbar('Failed to post your job. Please try again.', snackbarTypes.ERROR))
      dispatch(employerUserSignupPostJobFailure(error.response))
    }
  }
}

export const fetchCreateCheckoutSession = ({ customerEmail, source }) => {
  return async dispatch => {
    dispatch(
      fetchTrackEvent({
        eventName: 'checkout_started',
        eventType: ProductAnalyticsEventTypes.ACTION,
        distinctId: customerEmail,
        eventData: { source },
      }),
    )
    try {
      const response = await axios({
        url: '/api/employer_user_signup/create_checkout_session',
        method: 'POST',
        data: { customerEmail },
      })
      dispatch(
        fetchTrackEvent({
          eventName: 'checkout_redirect_started',
          eventType: ProductAnalyticsEventTypes.ACTION,
          distinctId: customerEmail,
          eventData: { source },
        }),
      )
      window.location.href = response.data.checkoutUrl
    } catch (error) {
      dispatch(showSnackbar('Failed to start checkout. Please try again.', snackbarTypes.ERROR))
    }
  }
}

export const fetchVerifyCheckoutSession = ({ sessionId }) => {
  return async dispatch => {
    try {
      const response = await axios({
        url: '/api/subscriptions/verify_checkout_session',
        method: 'POST',
        data: { sessionId },
      })
      if (response.data.isActive && response.data.identity) {
        dispatch(loginSuccess(response.data))
      }
      return response.data
    } catch (error) {
      dispatch(showSnackbar('Failed to verify your subscription. Please contact support.', snackbarTypes.ERROR))
      return null
    }
  }
}

const initialState = {
  validatingEmail: false,
  emailValidation: null,
  registering: false,
  registerResult: null,
  checkingConfirmation: false,
  confirmationResult: null,
  searchingEmployers: false,
  employerSearchResults: [],
  postingJob: false,
  postJobResult: null,
  errors: [],
}

export const employerUserSignupReducer = (state = initialState, action) => {
  const { payload } = action

  switch (action.type) {
    case VALIDATE_EMPLOYER_USER_EMAIL_LOADING:
      return {
        ...state,
        validatingEmail: true,
        emailValidation: null,
      }
    case VALIDATE_EMPLOYER_USER_EMAIL_SUCCESS:
      return {
        ...state,
        validatingEmail: false,
        emailValidation: payload,
      }
    case VALIDATE_EMPLOYER_USER_EMAIL_FAILURE:
      return {
        ...state,
        validatingEmail: false,
        errors: payload?.data?.errors ?? [],
      }
    case EMPLOYER_USER_SIGNUP_REGISTER_LOADING:
      return {
        ...state,
        registering: true,
        registerResult: null,
      }
    case EMPLOYER_USER_SIGNUP_REGISTER_SUCCESS:
      return {
        ...state,
        registering: false,
        registerResult: payload,
      }
    case EMPLOYER_USER_SIGNUP_REGISTER_FAILURE:
      return {
        ...state,
        registering: false,
        errors: payload?.data?.errors ?? [],
      }
    case EMPLOYER_USER_SIGNUP_CHECK_CONFIRMATION_LOADING:
      return {
        ...state,
        checkingConfirmation: true,
        confirmationResult: null,
      }
    case EMPLOYER_USER_SIGNUP_CHECK_CONFIRMATION_SUCCESS:
      return {
        ...state,
        checkingConfirmation: false,
        confirmationResult: payload,
      }
    case EMPLOYER_USER_SIGNUP_CHECK_CONFIRMATION_FAILURE:
      return {
        ...state,
        checkingConfirmation: false,
        errors: payload?.data?.errors ?? [],
      }
    case SEARCH_EMPLOYERS_LOADING:
      return {
        ...state,
        searchingEmployers: true,
      }
    case SEARCH_EMPLOYERS_SUCCESS:
      return {
        ...state,
        searchingEmployers: false,
        employerSearchResults: payload,
      }
    case SEARCH_EMPLOYERS_FAILURE:
      return {
        ...state,
        searchingEmployers: false,
        errors: payload?.data?.errors ?? [],
      }
    case EMPLOYER_USER_SIGNUP_POST_JOB_LOADING:
      return {
        ...state,
        postingJob: true,
        postJobResult: null,
      }
    case EMPLOYER_USER_SIGNUP_POST_JOB_SUCCESS:
      return {
        ...state,
        postingJob: false,
        postJobResult: payload,
      }
    case EMPLOYER_USER_SIGNUP_POST_JOB_FAILURE:
      return {
        ...state,
        postingJob: false,
        errors: payload?.data?.errors ?? [],
      }
    default:
      return { ...state }
  }
}
